"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";
import { normalizePath, trackEvent } from "@/lib/track";

// Fires one Umami event per navigation with a stable, aggregatable shape:
// name = feature area (first path segment), data.part = the full route
// pattern with dynamic segments collapsed. Raw pageview URLs are full of
// UUIDs/hashes and never aggregate; these events answer "how popular is each
// feature, and which part of it" in the Umami events report.
//
// The standalone public hosts are middleware REWRITES (src/proxy.ts), and
// usePathname() returns the browser path, not the rewritten app path: on
// saman.xd.is the path is "/", and on styrkja.xd.is/<token> the first segment
// is a raw capability token. Without the host map that traffic would be
// labeled "dashboard" or, worse, use the token itself as the event name.
const HOST_FEATURES: Record<string, string> = {
  "saman.xd.is": "saman",
  "styrkja.xd.is": "styrkja",
};

export function FeatureTracker() {
  const pathname = usePathname();

  useEffect(() => {
    if (!pathname) return;
    const hostFeature = HOST_FEATURES[window.location.hostname];
    const path = normalizePath(pathname);
    const part = hostFeature ? `/${hostFeature}${path === "/" ? "" : path}` : path;
    const feature = hostFeature ?? (part.split("/")[1] || "dashboard");
    trackEvent(feature, { part });
  }, [pathname]);

  return null;
}
